import React, {Fragment} from "react"
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import {connect} from 'react-redux'
import moment from 'moment'
import CircularProgress from '@material-ui/core/CircularProgress'

import {
  setSubject,
  setFromDate,
  setToDate,
  setDescription,
  setColor,
  setPrivate,
  fetchAppointment
} from '../../../actions/updateAppointmentActions'

import NavBar from "../../NavBar"

import Subject from './Subject'
import Subjects from './Subjects'
import Dates from './Dates'
import Color from './Color'
import Private from './Private'
import Description from './Description'

const styles = theme => ({
  form: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  hr: {
    width: '100%',
    height: '1px',
    border: '0',
    backgroundColor: 'rgba(0,0,0,0.12)'
  },
  progress:{
    margin: theme.spacing.unit
  }
})

class UpdateAppointment extends React.Component {
  constructor(props) {
    super(props)
    props.dispatch(fetchAppointment(props.match.params.id))
  }

  handleSubjectChange = (e) => {
    this.props.dispatch(setSubject(e.target.value))
  }

  handleFromDateChange = (e) => {
    this.props.dispatch(setFromDate(moment(e.target.value + ' ' + this.props.updateAppointment.fromDate.format('HH:mm'), 'YYYY-MM-DD hh:mm')))
  }

  handleFromTimeChange = (e) => {
    this.props.dispatch(setFromDate(moment(this.props.updateAppointment.fromDate.format('YYYY-MM-DD') + ' ' + e.target.value, 'YYYY-MM-DD hh:mm')))
  }

  handleToDateChange = (e) => {
    this.props.dispatch(setToDate(moment(e.target.value + ' ' + this.props.updateAppointment.toDate.format('HH:mm'), 'YYYY-MM-DD hh:mm')))
  }

  handleToTimeChange = (e) => {
    this.props.dispatch(setToDate(moment(this.props.updateAppointment.toDate.format('YYYY-MM-DD') + ' ' + e.target.value, 'YYYY-MM-DD hh:mm')))
  }

  handleEditorChange = () => {
    if(window.tinyMCE.get('editDescription') != null)
      this.props.dispatch(setDescription(window.tinyMCE.get('editDescription').getContent()))
  }

  handleColorChange = (e) => {
    this.props.dispatch(setColor(e.target.value))
  }

  handlePrivateChange = (e) => {
    this.props.dispatch(setPrivate(e.target.checked))
  }

  render() {
    const { classes } = this.props

    return (
      <div>
        <NavBar/>
          <Grid container justify="center">
            {this.props.updateAppointment.fetched ? (
              <Grid item md={6}>
                <form className={classes.form}>
                  <Subject
                    handleSubjectChange={this.handleSubjectChange}
                    updateAppointment={this.props.updateAppointment} />

                  <hr className={classes.hr}/>

                  <Dates
                    updateAppointment={this.props.updateAppointment}
                    handleFromDateChange={this.handleFromDateChange}
                    handleFromTimeChange={this.handleFromTimeChange}
                    handleToDateChange={this.handleToDateChange}
                    handleToTimeChange={this.handleToTimeChange} />

                  <hr className={classes.hr}/>

                  <Subjects />

                  <hr className={classes.hr}/>

                  <Color
                    handleColorChange={this.handleColorChange}
                    updateAppointment={this.props.updateAppointment} />

                  <hr className={classes.hr}/>

                  { !this.props.otherUser.loggedIn ? (
                    <Fragment>
                      <Private
                        handlePrivateChange={this.handlePrivateChange}
                        updateAppointment={this.props.updateAppointment}/>
                      <hr className={classes.hr}/>
                    </Fragment>
                  ) : (
                    null
                  )}

                  <Description
                    updateAppointment={this.props.updateAppointment}
                    locale={this.props.i18n.locale}
                    dispatch={this.props.dispatch}
                    handleEditorChange={this.handleEditorChange} />
                </form>
              </Grid>
            ) : (
              <CircularProgress className={classes.progress} />
            )}

          </Grid>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch
})

const mapStateToProps = (state) => ({
  updateAppointment: state.updateAppointment,
  i18n: state.i18n,
  otherUser: state.otherUser
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UpdateAppointment))



// WEBPACK FOOTER //
// ./src/js/components/pages/updateAppointment/UpdateAppointment.js